<div class="container">
	<div class="top-controls">
		<mat-form-field class="half-width" appearance="outline">
			<mat-select [(ngModel)]="currentGroup">
				<mat-option [value]="allGroupKey">
					{{ allGroupsLabel || ('shared.components.grouped-multiselect.all-groups-label' | translate) }}
				</mat-option>
				@for (group of groups; track group) {
					<mat-option [value]="group">{{ group }}</mat-option>
				}
			</mat-select>
		</mat-form-field>
		<mat-form-field class="half-width" appearance="outline">
			<input matInput type="text" [(ngModel)]="filterString" (ngModelChange)="onFilterChange()" [placeholder]="filterLabel || ('shared.components.grouped-multiselect.filter-label' | translate)" />
		</mat-form-field>
	</div>
	<div class="content">
		@if (currentGroup !== allGroupKey) {
			<ul class="ungrouped-item-list items-list">
				@for (item of groupedItems.get(currentGroup) ?? []; track $index) {
					<li class="list-item" (click)="onItemClicked(item)">
						{{ item.text }}
						<mat-icon aria-hidden="false" aria-label="Select item" fontIcon="keyboard_arrow_right"></mat-icon>
					</li>
				}
			</ul>
		} @else {
			<ul class="grouped-item-list items-list">
				@for (group of groups; track group) {
					<li>
						<span class="list-item group" (click)="onGroupClicked(group)">
							{{ group || ungroupedLabel || ('shared.components.grouped-multiselect.ungrouped-label' | translate) }}
							<mat-icon aria-hidden="false" aria-label="Select item" fontIcon="keyboard_arrow_right"></mat-icon>
						</span>
						<ul>
							@for (item of groupedItems.get(group) ?? []; track $index) {
								<li class="list-item" (click)="onItemClicked(item)">
									{{ item.text }}
									<mat-icon aria-hidden="false" aria-label="Select item" fontIcon="keyboard_arrow_right"></mat-icon>
								</li>
							}
						</ul>
					</li>
				}
			</ul>
		}
		<ul class="selected-item-list items-list">
			@for (item of selectedItems; track $index) {
				<li class="list-item" (click)="onSelectedItemClicked(item)">
					{{ item.text }}
					<mat-icon aria-hidden="false" aria-label="Deselect item" fontIcon="delete"></mat-icon>
				</li>
			}
		</ul>
	</div>
</div>
